export default __webpack_public_path__ + "static/media/bfr.86981b09.jpg";